import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css"; // Import stylů pro kalendář
import "./PublicHotelReservationForm.css"

const IframeBookingReservation = () => {
  const { businessId } = useParams(); // ID hotelu

  const [reservation, setReservation] = useState({
    checkInDate: null,
    checkOutDate: null,
    numberOfPeople: "",
    dog: false,
  });
  const [publicData, setPublicData] = useState([])
  const [sending, setSending] = useState(false)
  const [message, setMessage] = useState("");
  const [unavailableDates, setUnavailableDates] = useState([]); // Obsazené termíny
  const [selectingCheckOut, setSelectingCheckOut] = useState(false); // Přepínání výběru
  const [quest, setQuest] = useState({
    name: "",
    phone: "",
    email: "",
  })

  // 🔹 1. Načtení obsazených termínů z backendu
  useEffect(() => {
    const fetchUnavailableDates = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/booking/unavailable-dates`,
          { params: { businessId } } // Opravené odeslání parametru ve formátu objektu
        );
        setUnavailableDates(response.data);
      } catch (err) {
        console.error('Error fetching unavailable dates:', err);
        setMessage(err.response?.data?.message || 'Chyba při načítání dat.');
      }
    };
  
    if (businessId) {
      fetchUnavailableDates();
    }
  }, [businessId]);

  useEffect(() => {
    const fetchPublicData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/booking/public`, {
          params: {business: businessId}
        })
        setPublicData(response.data.data)
      } catch (err) {
        setMessage(err.response?.data?.message)
      }
    }
    fetchPublicData()
  }, [businessId])

  // 🔹 2. Kliknutí na datum v kalendáři (první = checkIn, druhé = checkOut)
  const handleDateChange = (date) => {
    if (!selectingCheckOut) {
      setReservation((prev) => ({
        ...prev,
        checkInDate: date,
        checkOutDate: null,
      }));
      setSelectingCheckOut(true);
    } else {
      if (reservation.checkInDate && date > reservation.checkInDate) {
        setReservation((prev) => ({
          ...prev,
          checkOutDate: date,
        }));
        setSelectingCheckOut(false);
      } else {
        setMessage("Datum odjezdu musí být po datu příjezdu");
      }
    }
  };

  // 🔹 3. Zakázání obsazených termínů v kalendáři
  const tileDisabled = ({ date }) => {
    return unavailableDates.some(
      (unavailable) =>
        new Date(unavailable).toDateString() === date.toDateString()
    );
  };

  const tileClassName = ({ date }) => {
    // Převod na YYYY-MM-DD ve správném časovém pásmu (UTC)
    const formatDate = (d) => new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())).toISOString().split('T')[0];
  
    // Aktuální datum a jeho sousedi
    const dateString = formatDate(date);
    const beforeDateString = formatDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
    const afterDateString = formatDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
  
    const isDisabled = unavailableDates.includes(dateString); // Kontrola pro celý den
    const isBeforeUnavailable = unavailableDates.includes(beforeDateString); // Kontrola pro předchozí den
    const isAfterUnavailable = unavailableDates.includes(afterDateString); // Kontrola pro následující den
  
    // Zkontrolujeme AM a PM pro příslušný den
    const isDisabledAM = unavailableDates.includes(dateString + " AM");
    const isDisabledPM = unavailableDates.includes(dateString + " PM");
  
    // Pokud je den zakázán
    if (isDisabled) return "disabled-day"; 
    if ((isBeforeUnavailable || isDisabledPM) && (isAfterUnavailable || isDisabledAM)) return "disabled-day"
  
    // Pokud je předchozí nebo následující den zakázán
    if (isBeforeUnavailable || isDisabledPM) return "before"; // Pokud předchozí den nebo PM pro tento den
    if (isAfterUnavailable || isDisabledAM) return "after"; // Pokud následující den nebo AM pro tento den
  
    return "opendays"; // Ostatní dny
  };

  // Zmena hodnoty inputu 
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setReservation((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const formSubmit = async (e) => {
    e.preventDefault();
    setSending(true)
    try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/booking/quest-create`,
          { reservation, business: businessId, quest }
        );
        setMessage(response.data.message);
    } catch (err) {
      setMessage(err.response?.data?.message || "Nastala chyba při vytváření rezervace.");
    } finally {
      setSending(false)
      setTimeout(() => {
        window.location.reload()
      }, 2000)
    }
  };

  /// Vypocet celkove ceny 
  const calculateTotalPrice = (reservation) => {
    // Získáme počet nocí mezi check-in a check-out
    const checkInDate = reservation.checkInDate;
    const checkOutDate = reservation.checkOutDate;

    if (!checkInDate || !checkOutDate) {
      return "0";
    }

    // Spočítáme rozdíl mezi daty (počet nocí)
    const timeDiff = checkOutDate - checkInDate;
    const numberOfNights = timeDiff / (1000 * 3600 * 24); // Převod milisekund na dny

    // Spočítáme cenu za ubytování
    const priceForNights = numberOfNights * publicData.pricePerNight;

    // Připočítáme poplatky
    const cleaningFee = publicData.cleaningFee || 0;
    const petFee = reservation.dog ? publicData.petFee : 0;

    // Celková cena
    const totalPrice = priceForNights + cleaningFee + petFee;

    return totalPrice;
  };

  const totalPrice = calculateTotalPrice(reservation);

  const handleQuestChange = (e) => {
    const {name, value} = e.target

    setQuest((prev) => ({
      ...prev,
      [name]: value,
    }))
    console.log(quest)
  }


  return (
    <div>
      <div className="business-container">
      <form onSubmit={formSubmit}>
        <Calendar
          onClickDay={handleDateChange}
          tileDisabled={tileDisabled} // Zakázání obsazených dat
          tileClassName={tileClassName}
          value={[reservation.checkInDate, reservation.checkOutDate]} // Zobrazení vybraného intervalu
          selectRange={true} // Povolení výběru rozsahu
        />
 <div className="check-conteiner-one-item">
    <div className="hotel-check">
    <h5 className="check-title">Jméno a příjmení:</h5>
    <input 
      className="hotel-input"
      type="text"
      id="name"
      name="name"
      value={quest.name}
      onChange={handleQuestChange}
      required
    />
  </div>
      <div className="hotel-check">
    <h5 className="check-title">Email:</h5>
    <input
      className="hotel-input" 
      type="email"
      id="email"
      name="email"
      value={quest.email}
      onChange={handleQuestChange}
      required
    />
  </div>
      <div className="hotel-check">
    <h5 className="check-title">Telefon:</h5>
    <input 
      className="hotel-input"
      type="text"
      id="phone"
      name="phone"
      value={quest.phone}
      onChange={handleQuestChange}
      required
    />
  </div>
  </div>    

<div className="check-conteiner">
  <div className="hotel-check">
    <h5 className="check-title">Příjezd:</h5><p>
    {reservation.checkInDate
    ? reservation.checkInDate.toLocaleDateString("cs-CZ")
    : "Není vybráno"}
    </p>
  </div>

  <div className="hotel-check">
    <h5 className="check-title">Odjezd:</h5><p>
    {reservation.checkOutDate
    ? reservation.checkOutDate.toLocaleDateString("cs-CZ")
    : "Není vybráno"}
    </p>
  </div>
</div>
<div className="check-conteiner">
<div className="hotel-number">
    <h5 className="check-title">Počet osob: </h5>
    <input
      className="hotel-input"
      placeholder={`Max počet osob: ${publicData.maxPeople}`}
      type="number"
      name="numberOfPeople"
      value={reservation.numberOfPeople}
      onChange={handleInputChange}
    />
  </div>

{publicData.pet && (
  <div className="hotel-number">
    <h5 className="check-title">Zvíře:</h5>
    <input
      type="checkbox"
      name="dog"
      checked={reservation.dog}
      onChange={handleInputChange}
      className="hotel-input-checkbox"
    />
  </div>
)}
</div>
<div className="check-conteiner">

<div className="hotel-price">
  <h2 className="check-title">Úklid:</h2> <p>{publicData.cleaningFee} Kč</p>
</div>
{reservation.dog && <div className="hotel-price"><h2 className="check-title">Poplatek za zvíře:</h2> <p>{publicData.petFee} Kč</p></div>}
</div>
<div className="total-price-container">
  <h2 className="check-title">Celková cena:</h2><h2 className="total-price">{totalPrice} Kč</h2>
</div>
<button className="hotel-submit-button" type="submit">{sending ? "Vytvářím...":"Potvrdit"}</button>

</form>
{message && <p className="message">{message}</p>}
    </div>
  </div>
  );
};

export default IframeBookingReservation